import { MODEL_KEY } from '../../../model'

export const REPORT_CLASS_NAME = 'Report'

export const REPORT_KEY = {

  ...MODEL_KEY,

  DATA: 'data',
  TYPE: 'type',
  FREQUENCY: 'frequency',
  START_DATE: 'startDate',
  END_DATE: 'endDate',
  PROFILE_ID: 'profileId',
  SHARE_KEY: 'shareKey',

  MEDIA: 'media'

}

export const REPORT_TYPE_DEPRECATED = {
  WEEKLY: 1,
  YEARLY: 2,
  QUARTERLY: 3
}

export const REPORT_TYPE = {
  YEAR_IN_REVIEW: 'YEAR_IN_REVIEW',
  ADMIN_REPORT: 'ADMIN_REPORT',
  FITNESS_SUMMARY: 'FITNESS_SUMMARY'
}

export const REPORT_FREQUENCY = {
  DAILY: 'DAILY',
  WEEKLY: 'WEEKLY',
  YEARLY: 'YEARLY',
  QUARTERLY: 'QUARTERLY'
}

export const REPORT_TYPE_DEPRECATED_TO_FREQUENCY = {
  [REPORT_TYPE_DEPRECATED.WEEKLY]: REPORT_FREQUENCY.WEEKLY,
  [REPORT_TYPE_DEPRECATED.YEARLY]: REPORT_FREQUENCY.YEARLY,
  [REPORT_TYPE_DEPRECATED.QUARTERLY]: REPORT_FREQUENCY.QUARTERLY
}
export const REPORT_PRIVATE_KEYS = []
export const REPORT_ASSOCIATION_KEYS = [
  REPORT_KEY.MEDIA
]

export const REPORT_SCOPE = {

  /**
   * Only returns the public attributes of the Post.
   * @type {Object}
   */
  defaultScope: {
    attributes: {
      exclude: REPORT_PRIVATE_KEYS
    }
  }

}

export const REPORT_AUDIT = {
  CREATED: 'Weekly Report Created',
  UPDATED: 'Weekly Report Updated',
  DELETED: 'Weekly Report Deleted'
}
